import { msg } from '@gonfalon/messages/msg';
import type { IconName } from '@launchpad-ui/icons';

export type ConnectionStatus = {
  label: string;
  variant: 'success' | 'warning' | 'error';
  icon: IconName;
};

// Maps a warehouse health status to its connection-status presentation.
// `connected_with_errors` renders as "Degraded" per design; unknown / undefined statuses have no mapping.
// Labels resolve in getConnectionStatus: this module is evaluated before the messages provider mounts.
const CONNECTION_STATUS: Record<string, Omit<ConnectionStatus, 'label'> & { label: () => string }> = {
  connected: {
    label: () => msg('integrations.connectionStatus.connected'),
    variant: 'success',
    icon: 'check-circle',
  },
  connected_with_errors: {
    label: () => msg('integrations.connectionStatus.degraded'),
    variant: 'warning',
    icon: 'warning',
  },
  disconnected: {
    label: () => msg('integrations.connectionStatus.disconnected'),
    variant: 'error',
    icon: 'alert-rhombus',
  },
};

export function getConnectionStatus(status?: string): ConnectionStatus | undefined {
  const entry = status ? CONNECTION_STATUS[status] : undefined;
  return entry ? { label: entry.label(), variant: entry.variant, icon: entry.icon } : undefined;
}

export function hasConnectionStatusTag(status?: string): boolean {
  return getConnectionStatus(status) !== undefined;
}
